/* MONTTCO — footer column accordion, mobile only (<=640px). Desktop forces
   every column open via CSS; ported from monttco-site/js/footer.js. */
(function(){
  "use strict";
  var footer = document.getElementById('footer');
  if (!footer) return;
  var isMobile = function(){ return window.matchMedia('(max-width:640px)').matches; };
  footer.querySelectorAll('.footer-col-toggle').forEach(function(btn){
    var body = btn.nextElementSibling;
    if (!body) return;
    btn.addEventListener('click', function(){
      if (!isMobile()) return;
      var open = body.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
